import React, { Component } from 'react';
import Layout from '../components/complex/layout';
import { Tabs, Tab } from 'react-bootstrap';
import BackgroundContent from './general/backgroundContent';
import HeaderContent from './general/headerContent';
import FooterContent from './general/footerContent';

class General extends Component {
  render () {
    return (
      <Layout>
        <h1 className="main-title">General</h1>

        <Tabs id="uncontrolled-tab-example" animation={false}>
          <Tab 
            eventKey={1}
            title="Background"
          >
            <BackgroundContent />
          </Tab>
          <Tab
            eventKey={2}
            title="Header"
          >
            <HeaderContent />
          </Tab>
          <Tab
            eventKey={3}
            title="Footer"
          >
            <FooterContent />
          </Tab>
        </Tabs>
      </Layout>
    )
  }
}

export default General;


// WEBPACK FOOTER //
// ./src/app/screens/general.js